import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <header className="bg-rd-bg border-b border-white/[0.07]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2 no-underline hover:opacity-80 transition-opacity">
          <img
            src={`${import.meta.env.BASE_URL}logo-icon.png`}
            alt="ReputeDesk"
            className="w-8 h-8 object-contain"
          />
          <span className="font-sora font-bold text-lg text-rd-text">ReputeDesk</span>
        </Link>

        <nav className="flex items-center gap-3">
          <Link
            to="/login"
            className="text-sm font-medium text-rd-muted hover:text-rd-text transition-colors"
          >
            Log in
          </Link>
          <Link
            to="/register"
            className="text-sm font-medium px-4 py-2 rounded-lg transition-colors"
            style={{ background: 'linear-gradient(135deg, #4ade80, #22d3ee)', color: '#0a0a0f' }}
          >
            Sign up
          </Link>
        </nav>
      </div>
    </header>
  )
}
